import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';

import { RdsAppToolbarComponent } from './app-toolbar.component';

@NgModule({
  imports: [CommonModule, FlexLayoutModule, MatToolbarModule, MatDividerModule, MatButtonModule, MatIconModule],
  exports: [RdsAppToolbarComponent],
  declarations: [RdsAppToolbarComponent],
})
export class RdsAppToolbarModule {}

export * from './app-toolbar.component';
